var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { get, post } from './api';
export const searchPlayers = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield get({ path: '/v1/players/search', params });
    return result;
});
export const addPlayerToMatch = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield get({ path: '/v1/players-in-match/create', params });
    return result;
});
export const removePlayerFromMatch = (playerId) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield get({ path: '/v1/players-in-match/remove-player', params: { playerId } });
    return result;
});
export const replacePosition = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield get({ path: '/v1/players-in-match/replace-position', params });
    return result;
});
export const loadPlayersInMatch = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/players-in-match', params: { matchId } });
    return response;
});
export const loadPayersInMatch = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/payers-in-match', params: { matchId } });
    return response;
});
export const getAdmins = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/matches/get-admins', params: { matchId } });
    return response;
});
export const createPlayer = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield post({ path: '/v1/players/create', data });
    return response;
});
export const setPaymentMethod = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/players-in-match/set-payment', params });
    return response;
});
export const setWireTransferPayment = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/players-in-match/set-wire-transfer-payment', params });
    return response;
});
export const setPaidByOtherPlayerPayment = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/players-in-match/set-other-player-payment', params });
    return response;
});
export const setPlayerRole = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/match-state/set-role', params });
    return response;
});
export const startPlayerIntroduction = (playerId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/introductions/start', params: { playerId } });
    return response;
});
export const selectIntroductionDirection = (playerId, direction) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/introductions/select-direction', params: { playerId, direction } });
    return response;
});
export const endPlayerIntroduction = (introductionId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/introductions/end', params: { introductionId } });
    return response;
});
export const startPlayerVote = (playerId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/votes/start', params: { playerId } });
    return response;
});
export const selectVoteDirection = (playerId, direction) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/votes/select-direction', params: { playerId, direction } });
    return response;
});
export const confirmPlayerVote = (voteId, targetId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/votes/confirm-vote', params: { voteId, targetId } });
    return response;
});
export const confirmPlayerPass = (voteId, targetId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/votes/confirm-pass', params: { voteId, targetId } });
    return response;
});
export const declineVote = (voteId, currentVoteId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/votes/decline-vote', params: { voteId, currentVoteId } });
    return response;
});
export const setMatchNight = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/phase-change/set-night', params: { matchId } });
    return response;
});
export const setMatchDay = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/phase-change/set-day', params: { matchId } });
    return response;
});
export const computeNightResults = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/phase-change/compute-night-results', params: { matchId } });
    return response;
});
export const shootoutChallenge = (shootoutId, number) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/shootouts/challenge', params: { shootoutId, number } });
    return response;
});
export const wakeUpRole = (role, matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/night/wake-up', params: { role, matchId } });
    return response;
});
export const performNightAction = (targetId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/night/perform', params: { targetId } });
    return response;
});
export const endSheriffCheck = (matchId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/night/end-sheriff-check', params: { matchId } });
    return response;
});
export const selectMatchEndCase = (matchId, winCase) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/match-state/end', params: { matchId, winCase } });
    return response;
});
export const setPlayerImmunity = ({ playerId, immunity }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/players-in-match/set-immunity', params: { playerId, immunity } });
    return response;
});
export const addPlayersFromMatch = ({ sourceId, targetId, copyRoles }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!targetId || !sourceId)
        return;
    const response = yield get({ path: '/v1/players-in-match/copy', params: { targetId, sourceId, copyRoles } });
    // eslint-disable-next-line consistent-return
    return response;
});
export const addFoul = (playerId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/tech-actions/add-foul', params: { playerId } });
    return response;
});
export const techKill = (playerId, reason) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/tech-actions/tech-kill', params: { playerId, reason } });
    return response;
});
export const bachelorSelectPlayer = (playerId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/votes/bachelor-select-player', params: { playerId } });
    return response;
});
